/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Urgency_C2aInputs */

const en_home_urgency_c2a = /** @type {(inputs: Home_Urgency_C2aInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long do we have?`)
};

/**
* | output |
* | --- |
* | "How long do we have?" |
*
* @param {Home_Urgency_C2aInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_urgency_c2a = /** @type {((inputs?: Home_Urgency_C2aInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Urgency_C2aInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_urgency_c2a(inputs)
});